import React, { useEffect } from 'react';
import { bool, node } from 'prop-types';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import { SUPPORTED_FIVERR_LOCALES_KEYS } from '@fiverr-private/localization';
import { sendMixpanelEvent } from '../../shared/biEvents';
import { EVENT_NAMES } from '../../shared/biEvents/eventNames';

import './style.scss';

const EntryWrapper = ({ removeBottomSpace = false, children, isV16 = false, isDarkTheme = false }) => {
    const { locale, isMobile } = getContext();

    useEffect(() => {
        sendMixpanelEvent({
            eventName: EVENT_NAMES.MIXPANEL.LOHP_BRAND_PAGE_VIEW,
            isV16,
        });
    }, [isV16]);

    const shouldApplyStyles = locale === SUPPORTED_FIVERR_LOCALES_KEYS.EN_US && !isMobile;

    return (
        <div
            className={classNames('logged-out-homepage', {
                'p-b-0': removeBottomSpace,
                'logged-out-homepage-de': locale === SUPPORTED_FIVERR_LOCALES_KEYS.DE_DE,
                'logged-out-homepage-test': shouldApplyStyles,
                'dark-theme': isDarkTheme,
            })}
        >
            {children}
        </div>
    );
};

EntryWrapper.propTypes = {
    removeBottomSpace: bool,
    children: node,
    isV16: bool,
    isDarkTheme: bool,
};

export default EntryWrapper;
